import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
/**
 * 转义符换成普通字符
 * @param {string} str - 待转换的字符串
 * @returns {string} 转换后的字符串
 */
export const Escape2Html = (str: string): string => {
  if (!str) return str;
  // 定义对象类型
  const arrEntities: { [key: string]: string } = {
    lt: "<",
    gt: ">",
    nbsp: " ",
    amp: "&",
    quot: '"',
  };
  return str.replace(
    /&(lt|gt|nbsp|amp|quot);/gi,
    function (all: string, t: string): string {
      return arrEntities[t];
    }
  );
};

/**
 * 用于处理对 props 进行赋值的情况
 * //简单处理一下就行了
 *
 * @param {T} target - 要克隆的目标对象
 * @returns {T} 克隆后的对象
 */
export const DeepClone = <T>(target: T): T => {
  return JSON.parse(JSON.stringify(target));
};

/**
 * 显示失败提示框
 * @param msg 提示信息
 * @param callback 回调函数
 */
export const ShowError = (msg: string, callback?: Function) => {
  ElMessageBox.alert(msg, "友情提示", {
    confirmButtonText: "确定",
    callback: () => {
      if (callback) {
        callback();
      }
    },
  });
};

/**
 * 显示成功提示框
 * @param duration 延迟时间
 * @param msg 提示信息
 * @param callback 回调函数
 */
export const ShowSuccessToast = (
  msg: string,
  callback?: Function,
  duration?: number
) => {
  duration = duration || 1500;
  ElMessage({
    message: msg,
    type: "success",
    duration: duration,
    onClose: () => {
      if (callback) {
        callback();
      }
    },
  });
};

/**
 * loading 加载效果
 * @param msg
 * @returns {*}
 */
export const ShowLoading = (msg?: string) => {
  return ElLoading.service({
    lock: true,
    text: msg || "加载中...",
    background: "rgba(0, 0, 0, 0.7)",
  });
};

/**
 * 解析 URL 中的查询字符串，返回参数键值对
 * @param url 包含查询字符串的 URL
 * @returns 参数键值对对象
 */
const parseUrlParams = (url: string): Record<string, string> => {
  const params: Record<string, string> = {};
  const queryIndex = url.indexOf("?");
  if (queryIndex !== -1) {
    const queryString = url.slice(queryIndex + 1);
    const keyValuePairs = queryString.split("&");
    keyValuePairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      if (key && value) {
        params[key] = decodeURIComponent(value);
      }
    });
  }
  return params;
};

/**
 * 跳转到内部或则外部链接
 * @param url  链接地址
 * @param type  replace  替换当前页面，不保留历史记录
 * @returns
 */
export const NavigateToUrl = (url: string, type?: string) => {
  if (!url) return;
  // 外部链接
  if (url.indexOf("http") > -1) {
    window.open(url, "_blank");
    return;
  }
  let query = parseUrlParams(url);
  // 内部链接
  navigateTo({
    path: url,
    query: query,
    replace: type == "replace" ? true : false,
  });
};

/**
 * 复制文本
 * @param text 需要复制的文本
 */
export const CopyText = async (text: string) => {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      ElMessage.success("复制成功");
    } catch (error) {
      ElMessage.error("复制失败");
    }
  } else {
    // 兼容旧浏览器
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        ElMessage.success("复制成功");
      } else {
        ElMessage.error("复制失败");
      }
    } catch (err) {
      ElMessage.error("复制失败");
    }
    document.body.removeChild(textArea);
  }
};
/**
 * base64转文件
 * @param base64  文件base64url
 * @param fileName 文件名称
 * @returns
 */
export const Base64ToFile = (base64, fileName) => {
  // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
  let data = base64.split(",");
  // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
  let type = data[0].match(/:(.*?);/)[1];
  // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
  let suffix = type.split("/")[1];
  // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
  const bstr = window.atob(data[1]);
  // 获取解码结果字符串的长度
  let n = bstr.length;
  // 根据解码结果字符串的长度创建一个等长的整形数字数组
  // 但在创建时 所有元素初始值都为 0
  const u8arr = new Uint8Array(n);
  // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
  while (n--) {
    // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
    u8arr[n] = bstr.charCodeAt(n);
  }
  // 利用构造函数创建File文件对象
  // new File(bits, name, options)
  const file = new File([u8arr], `${fileName}.${suffix}`, {
    type: type,
  });
  // 将File文件对象返回给方法的调用者
  return file;
};
